<td><reference-image [reference]="reference"></reference-image></td>
<td>{{ reference.isbn }}</td>
<td>{{ reference.title }}</td>
<td>{{ reference.authors }}</td>
<td>{{ reference.publisher }}</td>
<td>{{ supplierReference != null ? supplierReference.supplier.name : '&nbsp;' }}</td>
<td>{{ supplierReference != null ? (supplierReference.retailPrice / 100 | currency)  : '&nbsp;'  }}</td>
<td><reference-inventory [reference]="reference"></reference-inventory></td>
<td><a [routerLink]="['/inventory/reference', reference.isbn]"><i class="bi bi-card-heading"></i></a></td>